define(['basemodel'], (BaseModel) => BaseModel.extend({
    url: '/me',

    isAdmin () {
        return Boolean(this.get('is_admin'));
    }
}));
